import { useEffect, useState } from 'react';
import { executeCatalogCommand, getCatalogConfiguration, searchCatalog } from '../Services/mediaCatalog';
import { CatalogFilter } from '../Types/mediaCatalog';
import { useBizMutation, useBizQuery } from './useBizQuery';

export function useMediaCatalog(filter: CatalogFilter) {
	const [refreshAfterScan, setRefreshAfterScan] = useState(false);
	const configuration = useBizQuery(['MEDIA_CATALOG', 'CONFIGURATION'], getCatalogConfiguration);
	const files = useBizQuery(['MEDIA_CATALOG', 'FILES', filter], () => searchCatalog(filter));
	const command = useBizMutation(executeCatalogCommand, { getQueryKeyForInvalidation: () => [['MEDIA_CATALOG']] });
	const { refetch } = files;
	const hasActiveAnalysis = files.data?.some((item) => item.classification.status === 'queued' || item.classification.status === 'running') ?? false;
	useEffect(() => {
		if (!command.isSuccess || (command.variables?.action !== 'scan' && command.variables?.action !== 'scanUnscanned')) return;
		setRefreshAfterScan(true);
		const timeout = window.setTimeout(() => setRefreshAfterScan(false), 30000);
		return () => window.clearTimeout(timeout);
	}, [command.isSuccess, command.variables]);
	useEffect(() => {
		if (!hasActiveAnalysis && !refreshAfterScan) return;
		const timer = window.setInterval(() => {
			if (!document.hidden) void refetch();
		}, 10000);
		return () => window.clearInterval(timer);
	}, [hasActiveAnalysis, refreshAfterScan, refetch]);
	return { configuration, files, command };
}
